import React, { useMemo } from 'react';

const ComparisonItem = ({ plan, providers, removeComparisonPlan, position }) => {
  if (!plan.code) {
    return (
      <li className="item-selected-plans not-selected">
        <span className="desktop">Selecione outro seguro para comparar</span>
        <span className="mobile">Selecione outro plano</span>
      </li>
    );
  }

  const providerImgPath = useMemo(() => {
    const provider = providers.find((provider) => provider.code === plan.provider_code);
    return provider ? `/assets/images/seguradoras/${provider.slug}.png` : '';
  }, [providers, plan.provider_code]);


  return (
    <li
      className="item-selected-plans"
      onClick={() => removeComparisonPlan(plan.code)}
      data-cy={`plano-selecionado-p${position}`}
    >
      <span className="delete">
        <img src="/assets/images/pagamento/excluir.svg" alt="Excluir plano" />
      </span>
      <div className="mini">
        <img src={providerImgPath} alt={plan.provider_code ? 'Provider logo' : 'Sem logo'} />
      </div>
    </li>
  );
};

export default ComparisonItem;



// WEBPACK FOOTER //
// ./src/components/search/comparison_bar/ComparisonItem.jsx